module.exports = __webpack_public_path__ + "b2a546826ef6475e603df2489c226b60.png";